window.money_format = '${{amount}} USD';
window.cartType = 'mini-cart';
window.addToCartCallback = async (cart) => {
  try {
    // 1) Gọi API sections để lấy lại HTML của cart drawer + icon bubble
    const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];
    const url = `${window.Shopify?.routes?.root || '/'}?sections=${sectionsToRender.join(',')}`;

    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('Fetch sections failed');
    const data = await res.json();

    // 2) Parse HTML cho từng section và thay thế vào DOM hiện tại
    const parser = new DOMParser();

    // — Cart Drawer —
    if (data['cart-drawer']) {
      const drawerDoc = parser.parseFromString(data['cart-drawer'], 'text/html');
      const newDrawer = drawerDoc.querySelector('cart-drawer'); // element của Dawn
      const currentDrawer = document.querySelector('cart-drawer');

      if (newDrawer && currentDrawer) {
        // Thay nguyên element để giữ nguyên logic + events của Dawn
        currentDrawer.replaceWith(newDrawer);
      } else if (currentDrawer) {
        // Phòng trường hợp HTML trả về không bao bọc <cart-drawer>
        currentDrawer.innerHTML = drawerDoc.body.innerHTML;
      }
    }

    // — Cart Icon Bubble (số lượng trên icon giỏ) —
    if (data['cart-icon-bubble']) {
      const bubbleDoc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
      const newBubble = bubbleDoc.getElementById('cart-icon-bubble');
      const currentBubble = document.getElementById('cart-icon-bubble');
      if (newBubble && currentBubble) currentBubble.replaceWith(newBubble);
    }

    // 3) Mở cart drawer
    //    Dawn có method .open() trên custom element <cart-drawer>
    const drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && typeof drawerEl.open === 'function') {
      drawerEl.open();
    } else {
      // Fallback: phát sự kiện chuẩn của Dawn nếu theme của bạn dùng event
      document.dispatchEvent(new CustomEvent('cart:open'));
    }
  } catch (err) {
    console.error('[addToCartCallback] error:', err);
    // Fallback nhẹ: điều hướng sang cart page nếu có lỗi
    window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
  }
};